<script>
  import { onMount, tick } from 'svelte'
  import { urlParams } from '../base/store'
  import { debounce } from '../base/utils'
// Props
  export let key, factor=1
  const keyParam = `${key}_range`
  let values
  let low, high
// Constants
  const DELAY = 200
// Handlers
  const handle = i => debounce(DELAY, async e => {
    let value = e.target.value
    if (i === 0 && values[1] > 0 && value > values[1]) { values[1] = ""; high = "" }
    if (i === 1 && values[0] > 0 && value < values[0]) { values[0] = ""; low = "" }
    if (value > 0) value *= factor
    values[i] = value || ""
    if (!!values[0] || !!values[1]) urlParams.setParam(keyParam, values)
      else urlParams.removeParam(keyParam)
    await urlParams.applyFilters()
  })
  const set = () => {
    values = $urlParams[keyParam] || ['', ''];
    [low=null, high=null] = values.map(x =>
      x > 0 ? x / factor : x)
  }
  $: $urlParams && set()
</script>

<input type="number" id="cost" name="cost" min="0" placeholder="от" on:change={handle(0)} bind:value={low}>
<input type="number" id="cost" name="cost" min="0" placeholder="до" on:change={handle(1)} bind:value={high}>